// EXPLORER page interactions: column-count zoom stepper + tile background
// modes (ORANGE default / PICKER custom color), persisted per browser. The
// grid is server-rendered and styled via html[data-zoom]/[data-tilebg] hooks
// that rarity.html's head script restores before first paint — this module
// only updates those hooks (and localStorage) on clicks.

const LEVELS = [4, 6, 8, 12, 16, 24, 32, 48, 64, 100];
const ZOOM_KEY = "mdx-zoom-cols";
const MODE_KEY = "mdx-tilebg-mode";
const CUSTOM_KEY = "mdx-tilebg-custom";

const grid = document.getElementById("explorer-grid");
if (grid) {
  const root = document.documentElement;
  const mini = grid.classList.contains("mini");
  let zoom = Number(localStorage.getItem(ZOOM_KEY)) || 0;
  let custom = localStorage.getItem(CUSTOM_KEY) ?? "#F4F1EA";

  const applyZoom = () => {
    root.dataset.zoom = String(zoom);
    root.style.setProperty("--zoom-cols", String(zoom));
    if (zoom >= 16) root.dataset.zoomDense = "1";
    else delete root.dataset.zoomDense;
  };

  // ▲ = larger tiles (fewer columns), ▼ = smaller (more).
  const step = (d: number) => {
    const cur = zoom || (mini ? 24 : 12);
    let i = LEVELS.indexOf(cur);
    if (i === -1) {
      i = LEVELS.reduce(
        (best, v, j) => (Math.abs(v - cur) < Math.abs(LEVELS[best]! - cur) ? j : best),
        0,
      );
    }
    i = Math.min(Math.max(i + d, 0), LEVELS.length - 1);
    zoom = LEVELS[i]!;
    localStorage.setItem(ZOOM_KEY, String(zoom));
    applyZoom();
  };
  document.getElementById("zoom-out")?.addEventListener("click", () => step(1));
  document.getElementById("zoom-in")?.addEventListener("click", () => step(-1));

  const applyBg = (mode: string) => {
    if (mode === "picker") {
      root.dataset.tilebg = "picker";
      root.style.setProperty("--tile-custom", custom);
    } else {
      delete root.dataset.tilebg;
    }
    localStorage.setItem(MODE_KEY, mode);
  };
  for (const btn of document.querySelectorAll<HTMLElement>("[data-bg-mode]")) {
    btn.addEventListener("click", () => applyBg(btn.dataset.bgMode!));
  }
  const picker = document.getElementById("bg-custom") as HTMLInputElement | null;
  picker?.addEventListener("input", () => {
    custom = picker.value;
    localStorage.setItem(CUSTOM_KEY, custom);
    applyBg("picker");
  });
}
